import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'BankCard',
    props: {
        account: {},
        formatter: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock("div", {
                class: "card",
                style: _normalizeStyle('background-color: #' + (_ctx.account.bank.hexColour2 ? _ctx.account.bank.hexColour2.substring(2) : '000000'))
            }, [
                _createVNode(_component_v_row, { class: "nameRow" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "v-col-9 nameCol" }, {
                            default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(_ctx.account.bank.prettyName ? _ctx.account.bank.prettyName : _ctx.account.bank.name), 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.account.displayName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "right" }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    class: "bankLogo",
                                    src: _ctx.account.bank.logoPath ? require('@/assets/logos/' + _ctx.account.bank.logoPath) : _ctx.account.bank.logoUri
                                }, null, 8, _hoisted_1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-0" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "balanceCol" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatter.format(Math.round(_ctx.account.balance), false, false)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "balanceCol right" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatter.format(Math.round(_ctx.account.overdraftFacility), false, false)), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-1 mb-4" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "labelCol" }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode("Current balance")
                            ])),
                            _: 1
                        }),
                        _createVNode(_component_v_col, { class: "labelCol right" }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.account.accountType.prettyName == 'Current' ? 'Overdraft' : 'Credit') + " limit", 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row, { class: "mt-5" }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                            default: _withCtx(() => [
                                _createTextVNode("**** " + _toDisplayString(_ctx.account.accountNumber ? _ctx.account.accountNumber.substring(4) : ''), 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_row)
            ], 4));
        };
    }
});
